module.exports = __webpack_public_path__ + "static/img/img_solution_13.a78c541.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/msolution/img_solution_13.png
// module id = /383
// module chunks = 0